<button
  type="button"
  aria-label="Close"
  (click)="closed.emit()"
  class="flex items-center justify-center w-8 h-8 bg-transparent border-none p-0 cursor-pointer"
>
  <mat-icon svgIcon="ph-regular-x-square" class="icon-md text-error"></mat-icon>
</button>
